module.exports = __webpack_public_path__ + "assets/img/TCGL-2.8792ad9f.jpg";